import { buildUrl, handleRequest } from '@common/services/requestHelper';
import { RequestType } from '@common/services/types';

const basePath = process.env.REACT_APP_API_PATH;

const getIdentityProvider = async () => {
  const url = buildUrl(`/configuration/identity-provider`, basePath);

  return handleRequest({ url, requestType: RequestType.GET });
};

enum IdentityProviderType {
  AzureB2C = 'AzureB2C',
  AzureB2Cv2 = 'AzureB2Cv2',
}

export { getIdentityProvider, IdentityProviderType };
